import React from 'react'

import Base from '../_Base'

const Pc24 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M2.40039 5.08932L10.2469 4.0208L10.2503 11.5893L2.40752 11.634L2.40039 5.0894V5.08932ZM10.2431 12.4613L10.2491 20.0364L2.40647 18.9582L2.40602 12.4105L10.2431 12.4613ZM11.1943 3.88092L21.598 2.36255V11.493L11.1943 11.5755V3.88092ZM21.6004 12.5325L21.5979 21.6219L11.1942 20.1535L11.1797 12.5155L21.6004 12.5325Z" />
  </Base>
)

export default Pc24
